import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/courses.action'
import downloadDisabledUsers from 'api/courses/DownloadDisabledUsers'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'
import { prepareSearch } from 'helpers/courseSearch.helper'

async function downloadCourse(allSelected: boolean, ids: any[], q: any) {
  return downloadDisabledUsers(allSelected, ids, q)
}

function* coursesDownloadDisabledUsersEffectSaga(actions: any) {
  try {
    const { selectedRows, allSelected, params } = actions.payload
    const { searchText, usersFilter, fastFilters } = params

    const q = allSelected
      ? prepareSearch(searchText, usersFilter, fastFilters)
      : {}

    yield call(downloadCourse, allSelected, selectedRows, q)
    yield put(fromActions.Actions.updateCoursesDownloadDisabledUsers({
      loading: false,
    }))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.updateCoursesDownloadDisabledUsers({
      loading: false,
    }))
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* coursesDownloadDisabledUsersWatcherSaga() {
  yield takeLatest(fromActions.COURSES_DOWNLOAD_DISABLED_USERS, coursesDownloadDisabledUsersEffectSaga)
}
